module.exports = new __parcel__URL__("pvp_cancel_button.8637ebd9.png").toString();